<div class="card-blank"></div>

<div class="edit-mood-box mb-3 pt-2">
    <span  (click)="cancelUpdate()">
        <span class="comment-card-cancel"><i class="far fa-times"></i></span>
    </span>

    <h3 class="text-secondary fs-6 ps-2">{{'add_comment_mood' | translate}}</h3>
    <ul class="nav nav-pills mb-3 px-2 px-md-5">
        <li [ngClass]="{'active': mood.mood == 'excellent'}" (click)="mood.mood = 'excellent'">
            <a class="nav-pills-item" href="javascript:void(0)">
                <i class="icon-smileys-excellent"></i>
                @if(mood.mood == 'excellent'){
                    <p>{{'excellent' | translate}}</p>
                }
            </a>
        </li>
        <li [ngClass]="{'active': mood.mood == 'good'}" (click)="mood.mood = 'good'">
            <a class="nav-pills-item" href="javascript:void(0)">
                <i class="icon-smileys-good"></i>
                @if(mood.mood == 'good'){
                <p>{{ 'good' | translate}}</p>
                }
            </a>
        </li>
        <li [ngClass]="{'active': mood.mood == 'average'}" (click)="mood.mood = 'average'">
            <a class="nav-pills-item" href="javascript:void(0)">
                <i class="icon-smileys-average"></i>
                @if(mood.mood == 'average'){
                <p>{{ 'average' | translate}}</p>
                }
            </a>
        </li>
        <li [ngClass]="{'active': mood.mood == 'hard'}" (click)="mood.mood = 'hard'">
            <a class="nav-pills-item" href="javascript:void(0)">
                <i class="icon-smileys-hard"></i>
                @if(mood.mood == 'hard'){
                <p>{{ 'hard' | translate}}</p>
                }
            </a>
        </li>
        <li [ngClass]="{'active': mood.mood == 'bad'}" (click)="mood.mood = 'bad'">
            <a class="nav-pills-item" href="javascript:void(0)">
                <i class="icon-smileys-bad"></i>
                @if(mood.mood == 'bad'){
                <p>{{ 'bad' | translate}}</p>
                }
            </a>
        </li>
    </ul>

    <h3 class="text-secondary fs-6 ps-2 pt-2">{{'add_comment_comment_alt'|translate}}</h3>
    <div class="card-comment">
        <textarea id="mood-textarea-to-edit"
                  class="card-comment-body mood-textarea-to-edit"
                  name="moodComment"
                  [formControl]='moodCommentCtrl'
                  [attr.placeholder]="'add_comment_placeholder' | translate"></textarea>

        <tm-mood-pickers (onElement)="fromMoodPicker($event)"></tm-mood-pickers>

        <div class="timeline-item-to-edit-actions">
            <button (click)="saveUpdate()" class="btn btn-sm btn-outline-secondary"
                    [disabled]="mood.comment?.body?.length === 0">
                {{'save' | translate}} <i class="far fa-check"></i>
            </button>
        </div>
    </div>
</div>